import {enableProdMode, provideZonelessChangeDetection} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if ( environment.production )
{
    enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZonelessChangeDetection()], })
    .catch(err => console.error(err));

export const TOPIC = '/topic';
const USER = '/user';
export const USER_TOPIC = `${USER}${TOPIC}`;
